export const Text = ({ children, name, style }) => {
    const className = name ? `text__${name}` : 'text';
    return (
        <div className={className} style={style}>
            {children}
        </div>
    );
};
